import './scss/index.scss';
import OfferComponent from './js/offer.component';
import OfferFormComponent from './js/offer-form.component';
import ComponentsCollection from '../../general/js/components-collection';

ComponentsCollection.getInstance().define('offer', OfferComponent);

ComponentsCollection.getInstance().define('offer-form', OfferFormComponent);



// WEBPACK FOOTER //
// ./app/components/offer/index.js